<gsp-notification class="info" *ngIf="information">
    {{ information }}
</gsp-notification>
